import React from 'react';
import { colors } from './theme';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

export default function MtbfEachDeviceCard({ products }) {
  const list = Array.isArray(products) ? products : [];

  return (
    <div style={{ ...card.shell, maxWidth: '760px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Per product</p>
          <h2 style={card.title}>MTBF Each Device</h2>
        </div>
      </div>
      <div style={card.body}>
        <div style={card.section}>
          {list.length > 0 ? (
            <ul style={{ ...card.list, color: colors.textBody }}>
              {list.map(product => {
                const rawHours = typeof product.totalOperatingTime === 'number' ? product.totalOperatingTime : null;
                const failures = Number(product.failures) || 0;
                const mtbfHours = failures > 0 && rawHours !== null ? Math.round(rawHours / failures) : null;
                const mtbfYears = mtbfHours !== null ? Math.round(mtbfHours / 8760) : null;
                return (
                  <li key={product.productNumber} style={{ marginBottom: '0.9rem' }}>
                    <div style={{ color: colors.textStrong, fontWeight: 600 }}>
                      {product.productNumber}: {mtbfHours !== null ? mtbfHours.toLocaleString() : 'N/A'} hours / {mtbfYears !== null ? mtbfYears.toLocaleString() : 'N/A'} years
                    </div>
                    <div style={{ fontSize: '0.85rem', color: colors.textMuted }}>
                      Based on {rawHours !== null ? Math.round(rawHours).toLocaleString() : 'N/A'} cumulative operating hours.
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div style={{ color: colors.textMuted }}>No data available</div>
          )}
        </div>
      </div>
    </div>
  );
}
